import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useBasemapEnableMutation } from "@/v2-backoffice-client/basemap/enable/basemap.enable.mutation"
import type { BasemapFragment } from "@/v2-backoffice-client/basemap/__types__/basemap.fragment"

export type BasemapEnableMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  basemap: BasemapFragment
}

function BasemapEnableMenuItem(props: BasemapEnableMenuItemProps) {
  const { basemap, children, ...menuItemProps } = props

  const [toggle, { loading, error }] = useBasemapEnableMutation()

  const isEnabled = basemap.IsEnabled

  return (
    <ActionMenu.Item
      iconSrc={isEnabled ? "eye-crossed" : "eye"}
      isLoading={loading}
      error={error}
      errorTitle="Failed to toggle basemap"
      onSelect={(event) => {
        event.preventDefault()
        toggle({
          variables: {
            featureCode: basemap.FeatureCode,
            isEnabled: !isEnabled,
          },
        })
      }}
      {...menuItemProps}
    >
      {children ?? (isEnabled ? "Disable Basemap" : "Enable Basemap")}
    </ActionMenu.Item>
  )
}

export default BasemapEnableMenuItem
